import React from "react";
import "./Contact.css"; // Import styles
import "bootstrap-icons/font/bootstrap-icons.css"; // Import Bootstrap Icons

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="container-fluid">
        <div className="row g-0">
          {/* Left Side: Company Image */}
          <div className="col-md-6 contact-image">
            <div className="overlay"></div>
            <img src="/images/About.png" alt="Company" />
            <div className="image-text">
              <h2>PTC Solutions</h2>
              <p>Innovating Industrial Automation</p>
            </div>
          </div>

          {/* Right Side: Contact Details */}
          <div className="col-md-6 contact-details d-flex flex-column justify-content-center p-5">
            <h2 className="fw-bold mb-4">Get in Touch</h2>

            <p className="detail-item">
              <i className="bi bi-geo-alt-fill"></i>
              Survey No 47, Plot No. 5, Jambhulwadi Road,
              <br /> near Mudra Hotel, Pune, Maharashtra 411046
            </p>

            <p className="detail-item">
              <i className="bi bi-telephone-fill"></i>
              +91-8329287300
            </p>

            <p className="detail-item">
              <i className="bi bi-envelope-fill"></i>
              ptransandcontrols@gmail.com
            </p>

            <p className="detail-item">
              <i className="bi bi-globe2"></i>
              www.ptcsolutions.com
            </p>

            <button className="btn btn-primary mt-4 w-50 shadow">
              📍 Get Directions
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
